import { Observable } from 'rxjs';
import { UpdateTerminalRequest } from '@app/data/dtos/tpv/terminal-update.dto';

/**
 * Port abstracto para el ciclo de vida de una terminal en el TPV (escritura) — §4.
 * Permiso backend: IsAdmin. Estos endpoints NO llevan `Idempotency-Key` obligatoria.
 *
 * `idTerminal` es la clave natural de la terminal (string libre, NO UUID).
 */
export abstract class TerminalLifecycleRepository {
  /** Edición parcial: al menos un campo en el cuerpo plano. */
  abstract updateTerminal(
    idTerminal: string,
    payload: UpdateTerminalRequest,
  ): Observable<void>;

  /** Baja de la terminal. */
  abstract deleteTerminal(idTerminal: string): Observable<void>;
}
